export default {
    403: {
        img: require('./images/icon-403.svg'),
        imgColor: require('./images/icon-403-color.svg'),
        title: '403',
        desc: '抱歉，你无权访问该页面',
    },
    404: {
        img: require('./images/icon-404.svg'),
        imgColor: require('./images/icon-404-color.svg'),
        title: '404',
        desc: '抱歉，你访问的页面不存在',
    },
    500: {
        img: require('./images/icon-500.svg'),
        imgColor: require('./images/icon-500-color.svg'),
        title: '500',
        desc: '抱歉，服务器出错了',
    },
};